import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';
import { InsuranceWebDto } from '@/features/dashboard/insurances/types/InsuranceWebDto.ts';
import { InsuranceListDto } from '@/features/dashboard/insurances/types/InsuranceListDto.ts';

const insurancesApi = {
  create: async (dto: InsuranceWebDto): Promise<InsuranceWebDto> => {
    return await fetchPrivateApi<InsuranceWebDto>('POST', `insurances`, dto);
  },
  update: async (
    id: string,
    dto: InsuranceWebDto,
  ): Promise<InsuranceWebDto> => {
    return await fetchPrivateApi<InsuranceWebDto>(
      'PUT',
      `insurances/${id}`,
      dto,
    );
  },
  get: async (id: string): Promise<InsuranceWebDto> => {
    return await fetchPrivateApi<InsuranceWebDto>('GET', `insurances/${id}`);
  },
  getList: async (): Promise<InsuranceWebDto[]> => {
    return await fetchPrivateApi<InsuranceWebDto[]>('GET', `insurances`);
  },
  remove: async (id: string): Promise<void> => {
    return await fetchPrivateApi<void>('DELETE', `insurances/${id}`);
  },
  getAll: async (
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<InsuranceListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return await fetchPrivateApi<PagedDto<InsuranceListDto>>(
      'POST',
      `insurances/all?${params.toString()}`,
      filterCriteria,
    );
  },
  getTableDefinition: async (): Promise<TableDefinitionDto> => {
    return await fetchPrivateApi<TableDefinitionDto>(
      'GET',
      `insurances/table-definition`,
    );
  },
};

export default insurancesApi;
